import type ModalStore from '@/stores/modal/modal';
import type { NotificationStore } from '@/stores/notification/notification';

export class PlaylistModal {
    private videoId: string;

    constructor(videoId: string) {
        this.videoId = videoId;
    }

    closeModal(): void {
        try {
            const modalStore = Alpine.store('modal') as ModalStore;
            modalStore.closeModal('playlist');
        } catch (error) {
            console.error('Failed to close modal:', error);
        }
    }

    handleAfterRequest(event: CustomEvent, successMessage: string = 'Success'): void {
        try {
            this.closeModal();
            if (event.detail && event.detail.successful) {
                const notificationStore = Alpine.store('notification') as NotificationStore;
                notificationStore.create({
                    type: 'success',
                    message: successMessage,
                });
            }
        } catch (error) {
            console.error('Failed to handle after request:', error);
        }
    }

    getVideoId(): string {
        return this.videoId;
    }
}
